export default "__VITE_ASSET__B3elFi_v__"